import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
    } from '@/components/ui/alert-dialog';
    import { computed } from 'vue';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { useMutation } from '@tanstack/vue-query';
    import { useQueryClient } from '@tanstack/vue-query';
    import axios from 'axios';
    import QueryKey from '@/enums/QueryKey';
    import type { Payslip, AuthUser } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PayslipApprove',
  props: {
    payslip: {},
    modelValue: { type: Boolean },
    user: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const { t } = useI18n();

    const queryClient = useQueryClient();

    const props = __props;

    const emit = __emit;

    const open = computed({
        get: () => props.modelValue ?? false,
        set: (value) => emit('update:modelValue', value),
    });

    const { mutate, isPending } = useMutation({
        mutationFn: (formData: { id: number; approverUserName: string }) =>
            axios.post(route('v2.salary.payslip.approve'), formData),
        onSuccess: (data) => {
            toast.success(data.data.success);
            queryClient.invalidateQueries({
                queryKey: [QueryKey.PAYROLLS, props.user.selected_company_id],
            });
        },
        onError: (error: any) => {
            toast.error(error.response.data.error || t('forms.system_error'));
        },
    });

    function approvePayslip() {
        mutate({
            id: props.payslip.id,
            approverUserName: props.user.name,
        });
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialog), {
    open: open.value,
    "onUpdate:open": _cache[0] || (_cache[0] = (value) => (open.value = value))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('salary.pay_slips.js.approve.title')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('salary.pay_slips.js.approve.content')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('forms.no')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogAction), {
                onClick: approvePayslip,
                variant: "default"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('pay-slips.approve')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})